import {useState} from 'react';
import PortableText from '../portableText/PortableText.client';
import {motion, AnimatePresence} from 'framer-motion';
import type {PortableTextBlock} from '@sanity/types';
import PlusIcon from '../icons/Plus';
import MinusIcon from '../icons/Minus';

type BodyItem = {
  heading: string;
  copy: PortableTextBlock[];
};

type Props = {
  body: BodyItem[];
};

export default function InfoAccordion({body}: Props) {
  const [active, setActive] = useState<number | null>(null);
  return (
    <div className="mt-5">
      {body.map((item, index) => {
        return (
          <AccordionItem
            key={index}
            heading={item.heading}
            copy={item.copy}
            active={active}
            setActive={setActive}
            index={index}
          />
        );
      })}
    </div>
  );
}

type AccordionItemProps = {
  heading: string;
  copy: PortableTextBlock[];
  active: number | null;
  setActive: (index: number | null) => void;
  index: number;
};

const AccordionItem = (props: AccordionItemProps) => {
  const isActive = props.active === props.index;
  const handleClick = () =>
    !isActive ? props.setActive(props.index) : props.setActive(null);

  return (
    <div>
      <div
        onClick={handleClick}
        className="flex cursor-pointer items-center justify-between border-t border-dark-grey py-5"
      >
        <h3 className="blockH9 font-semibold text-dark-grey">
          {props.heading}
        </h3>
        {
          <span className="text-dark-grey">
            {isActive ? <MinusIcon /> : <PlusIcon />}
          </span>
        }
      </div>

      <AnimatePresence>
        {isActive && (
          <motion.div
            initial={{opacity: 0, height: 0}}
            animate={{opacity: 1, height: 'auto'}}
            exit={{opacity: 0, height: 0}}
            className=" overflow-hidden"
          >
            {props.copy && <PortableText blocks={props.copy} />}
            <div className="h-5" />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
